module.exports = __webpack_public_path__ + "static/media/css.d337b7ee.svg";